import { render, staticRenderFns } from "./PC.vue?vue&type=template&id=a6446d00&"
import script from "./PC.vue?vue&type=script&lang=js&"
export * from "./PC.vue?vue&type=script&lang=js&"
import style0 from "./PC.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports